import "react-sliding-pane/dist/react-sliding-pane.css";

import {
  Col,
  ControlLabel,
  Dropdown,
  FormControl,
  FormGroup,
  Grid,
  MenuItem,
  Row
} from "react-bootstrap";
import { FormattedMessage, injectIntl } from "react-intl";

import BankImportFormatSelect from "../bankImport/BankImportFormatSelect";
import BankImportUploader from "../bankImport/BankImportUploader";
import Button from "../../elements/CustomButton/CustomButton";
import { CancelButton } from "../../elements/ActionButtons/index";
import Card from "../Card/Card";
import Cleave from "cleave.js/react";
import CurrencyInput from "../Currency/CurrencyInput";
import CurrencySelect from "../Currency/CurrencySelect";
// import { FIELD_NAME } from "../../containers/Articles/constants";
import NotificationProvider from "../../elements/NotificationContent/Notifications";
import PaymentLastUpdate from "../Payment/PaymentList/PaymentLastUpdate";
import Queries from "../../queries/queries2";
import React from "react";
import ReactSlidingPane from "react-sliding-pane";
import { SaveButton } from "../../elements/ActionButtons/index";
import Spinner from "../../elements/Spinner/Spinner";
import SuperpositionHeader from "../Header/SuperpositionHeader";
import { compose } from "recompose";
import fusionSVG from "../../assets/img/fusion.svg";
import { graphql } from "react-apollo";
import moment from "moment-timezone";
import unsyncSVG from "../../assets/img/unsync.svg";
import { viewPortDimension } from "../../tools/viewportDimension";
import { withRouter } from "react-router-dom";

class BankAccountForm extends React.Component {
  constructor(props) {
    super(props);

    this.INITIAL_STATE = {
      id: null,
      name: "",
      currencyId:
        (props.bankAccountFromQuery &&
          props.bankAccountFromQuery.currency &&
          props.bankAccountFromQuery.currency.id) ||
        ((props.defaultCurrencyUSD &&
          props.defaultCurrencyUSD.currency &&
          props.defaultCurrencyUSD.currency.id) ||
          null),
      dateCloture: null,
      typeBankAccount: "",
      iban: "",
      alertMaxMontant: 0.0,
      alertMaxSolde: 0.0,
      alertMinMontant: 0.0,
      alertMinSolde: 0.0,
      codeJournal: "",
      active: false,
      syncAccount: false,
      importedAccount: true,
      importFormat: "IMPORT_BANKOFAMERICA"
    };

    this.state = props.client ? props.client : this.INITIAL_STATE;

    this.state = {
      bankAccount: props.bankAccountFromQuery
        ? this.getStateObject(props.bankAccountFromQuery)
        : this.INITIAL_STATE,
      isPaneOpen: false,
      isPaneImport: false,
      actionRunning: false,
      password: undefined,
      paneTitleIds: "",
      paneContentIds: ""
    };
  }

  validate = values => {
    if (values.name === "") {
      return "badName";
    }
    return null;
  };

  onCancel = ({ setBankAccount, getStateObject, bankAccountFromQuery }) => {
    this.setState({
      bankAccount: this.getStateObject(this.bankAccountFromQuery)
    });
  };

  onSave = () => {
    //
    //  TO DO : VALIDATE DATA
    //
    const valRes = this.validate(this.state.bankAccount);

    if (!!!valRes) {
      this.props.onSave(this.state.bankAccount);
      return;
    }
    console.log("error", valRes);
    if (valRes === "badName") {
      this.setState({ errors: { nameValidation: "error" } });
    }
    // name, currency, format
  };

  showUnsyncSlidingPane = () => {
    this.setState({
      isPaneOpen: true,
      isPaneImport: false,
      paneTitleIds: this.props.intl.formatMessage({ id: "ids_confirm" }),
      paneContentIds: this.props.intl.formatMessage({
        id: "ids_confirmUnsyncBankAccountContent"
      }),
      ids_paneActionSuccess: this.props.intl.formatMessage({
        id: "ids_updateSuccessful"
      }),
      ids_paneActionFailed: this.props.intl.formatMessage({
        id: "ids_unsyncedAccountFailedNotification"
      }),

      paneConfirmAction: async () => {
        console.log("do unsync this.state.bankAccount", this.state.bankAccount);
        this.props.onUnsynchronize(this.state.bankAccount);
      }
    });
  };

  showImportSlidingPane = () => {
    this.setState({
      isPaneOpen: true,
      isPaneImport: true,
      paneTitleIds: this.props.intl.formatMessage({ id: "ids_import" }),
      // paneContentIds: this.props.intl.formatMessage({
      //   id: "ids_importBankAccountContent"
      // }),
      ids_paneActionSuccess: this.props.intl.formatMessage({
        id: "ids_importSuccessful"
      }),
      ids_paneActionFailed: this.props.intl.formatMessage({
        id: "ids_importFailedNotification"
      }),

      paneConfirmAction: async values => {
        console.log(
          "this.state.bankAccount imported",
          this.state.bankAccount,
          values
        );
      }
    });
  };

  showCloseSlidingPane = () => {
    this.setState({
      isPaneOpen: true,
      isPaneImport: false,
      paneTitleIds: this.props.intl.formatMessage({ id: "ids_confirm" }),
      paneContentIds: this.props.intl.formatMessage({
        id: "ids_confirmCloseBankAccountContent"
      }),
      ids_paneActionSuccess: this.props.intl.formatMessage({
        id: "ids_updateSuccessful"
      }),
      ids_paneActionFailed: this.props.intl.formatMessage({
        id: "ids_closeAccountFailedNotification"
      }),

      paneConfirmAction: async () => {
        console.log("do unsync this.state.bankAccount", this.state.bankAccount);
        this.props.onCloseAccount(this.state.bankAccount);
      }
    });
  };

  showMergeSlidingPane = () => {

    this.setState({
      isPaneOpen: true,
      isPaneImport: false,
      paneTitleIds: this.props.intl.formatMessage({ id: "ids_confirm" }),
      paneContentIds: (
        <div>
          {this.props.intl.formatMessage({ id: "ids_confirmMergeBankAccountContent_1" })}
          <br />
          {this.props.intl.formatMessage({ id: "ids_confirmMergeBankAccountContent_2" })}
        </div>
      ),
      ids_paneActionSuccess: this.props.intl.formatMessage({
        id: "ids_updateSuccessful"
      }),
      ids_paneActionFailed: this.props.intl.formatMessage({
        id: "ids_mergeAccountFailedNotification"
      }),
      ids_paneActionPasswordError: this.props.intl.formatMessage({
        id: "ids_passwordError",
        defaultMessage: "Le mot de passe est incorrect."
      }),

      paneConfirmAction: async () => {
        console.log("do merge this.state.bankAccount", this.state.bankAccount);
        this.props.onMergeAccount(this.state.bankAccount);
      }
    });
  };

  showDeleteSlidingPane = () => {
    this.setState({
      isPaneOpen: true,
      isPaneImport: false,
      paneTitleIds: this.props.intl.formatMessage({ id: "ids_confirm" }),
      paneContentIds: this.props.intl.formatMessage({
        id: "ids_confirmDeleteBankAccountContent"
      }),
      ids_paneActionSuccess: this.props.intl.formatMessage({
        id: "ids_updateSuccessful"
      }),
      ids_paneActionFailed: this.props.intl.formatMessage({
        id: "ids_deleteAccountFailedNotification"
      }),
      ids_paneActionPasswordError: this.props.intl.formatMessage({
        id: "ids_passwordError",
        defaultMessage: "Le mot de passe est incorrect."
      }),

      paneConfirmAction: async () => {
        console.log("do merge this.state.bankAccount", this.state.bankAccount);
        this.props.onDeleteAccount(this.state.bankAccount);
      }
    });
  };
  // onCloseAccount = () => {
  //   // this.props.onCloseAccount(this.state.bankAccount);
  // };

  // onMergeAccount = () => {
  //   // this.props.onMergeAccount(this.state.bankAccount);
  // };
  // onDeleteAccount = () => {
  //   // this.props.onDeleteAccount(this.state.bankAccount);
  // };

  onPaneConfirm = async event => {
    if (!!!this.state.isPaneImport) {
      const res = await this.validatePassword();

      if (res) {
        this.setState({ actionRunning: true });

        this.state.paneConfirmAction(event);
        this.setState({ actionRunning: false });

        let notif = NotificationProvider.getSuccessNotification();
        notif.message = this.state.ids_paneActionSuccess;
        this.props.sendNotification(notif);

        this.setState({ isPaneOpen: false });
        setTimeout(() => {
          this.props.history.push("/payments");
        }, 1500);
      } else {
        let notif = NotificationProvider.getPasswordFailureNotification();
        notif.message = this.state.ids_paneActionPasswordError;

        this.setState({ isPaneOpen: false });
        this.props.sendNotification(notif);
      }
    } else {
      let success = false;

      const result = await this.props.onImportBankTransactions(event.fileUrl);
      if (result && result.data && result.data.importBankTransactions) {
        success = result.data.importBankTransactions.result;
      }

      if (success) {
        this.setState({ actionRunning: true });

        this.state.paneConfirmAction(event);
        this.setState({ actionRunning: false });

        let notif = NotificationProvider.getSuccessNotification();
        notif.message = this.state.ids_paneActionSuccess;
        this.props.sendNotification(notif);

        this.setState({ isPaneOpen: false });
        setTimeout(() => {
          this.props.history.push("/payments");
        }, 1500);
      } else {
        let notif = NotificationProvider.getFailureNotification();
        notif.message = this.state.ids_paneActionFailed;

        this.setState({ isPaneOpen: false });
        this.props.sendNotification(notif);
      }
    }
  };

  updateFormValue = (key, value) => {
    return this.setState({
      bankAccount: { ...this.state.bankAccount, [key]: value }
    });
  };

  getStateObject = props => {
    const {
      id,
      dateCloture,
      alertMaxMontant,
      alertMaxSolde,
      alertMinMontant,
      alertMinSolde,
      iban,
      name,
      syncAccount,
      importedAccount,
      typeBankAccount,
      codeJournal,
      currency,
      providerAccount
    } = props;
    return {
      id,
      dateCloture,
      alertMaxMontant,
      alertMaxSolde,
      alertMinMontant,
      alertMinSolde,
      iban,
      name,
      syncAccount,
      importedAccount,
      typeBankAccount,
      codeJournal,
      currencyId: currency && currency.id,
      providerAccountError: providerAccount && providerAccount.error,
      importFormat: providerAccount && providerAccount.provider
    };
  };

  validatePassword = async e => {
    e && e.preventDefault();
    const userProfile = this.props.userProfile;
    const { password } = this.state;

    let res = false;
    try {
      let returnedValue = await this.props.authenticateUserMutation({
        variables: { email: userProfile.loggedInUser.email, password }
      });

      console.log("returnedValue", returnedValue);

      if (returnedValue.data !== null) res = true;
    } catch (e) {
      return res;
    }
    return res;
  };

  render = () => {
    // const {
    //   // bankAccountFromQuery
    //   //updateFormValue,
    //   // onCancel,
    //   // onUnsynchronize,
    //   // onCloseAccount,
    //   // onDeleteAccount,
    //   // onMergeAccount,
    //   //onSave
    // } = this.props;
    const { bankAccount, isPaneOpen, actionRunning } = this.state;
    // if (!bankAccount) return <Spinner size="lg" fullScreen />;

    if (!bankAccount || actionRunning) return <Spinner size="lg" fullScreen />;

    console.log("render", this.state);
    //const popoverClick = (
    //  <Popover id="popover-trigger-click" title="Fusionner avec :">
    //    {/*<BankAccountSelect
    //          companyId={companyId}
    //
    //          bankAccounts={bankAccounts}
    //          onSelected={element =>
    //              handleFilterChange("bankAccountSelected", element.account)
    //          }
    //          value={bankAccountSelected.id}
    //      />*/}
    //    <div>oui</div>
    //    {console.log("PROPS", this.props)}
    //  </Popover>
    //);*/
    const dimension = viewPortDimension();

    const slidingPaneWidth =
      Math.min(dimension.width - 200, 800).toString() + "px";

    const password = "password";

    const intl = this.props.intl;
    const locale = `${intl.locale.split("-")[0]}`;

    let closedAtDate = "";
    if (bankAccount.dateCloture) {
      console.log("intl", intl);
      console.log("locale", locale);

      if (locale !== "en") {
        // en is enabled by default already
        import(`moment/locale/${locale}`).then(() => {
          moment.locale(locale);
        });
      }
      closedAtDate = moment(bankAccount.dateCloture, "YYYY-MM-DD HH:mm")
        .tz(moment.tz.guess())
        .format("L");
    }

    //console.log("closedAtDate=", closedAtDate);
    let backBtnText2 = bankAccount.name;

    if (backBtnText2 === "")
      backBtnText2 = <FormattedMessage id="ids_new" />;

    console.log("THIS=", this);

    // const borderColor = "hsl(0,0%,80%)";
    // const styleError = {
    //   borderColor: `#b94a48 ${borderColor}`,
    //   border: "1px solid red"

    const userId =
      (this.props.bankAccountFromQuery &&
        this.props.bankAccountFromQuery.company &&
        this.props.bankAccountFromQuery.company.biConnexion &&
        this.props.bankAccountFromQuery.company.biConnexion.userId) || null;

    // const connexionId =
    //   (this.props.bankAccountFromQuery &&
    //     this.props.bankAccountFromQuery.company &&
    //     this.props.bankAccountFromQuery.company.biConnexion &&
    //     this.props.bankAccountFromQuery.company.biConnexion.connexionId) || null;

    const connexionId =
      ((this.props.bankAccountFromQuery &&
        this.props.bankAccountFromQuery.providerAccount &&
        this.props.bankAccountFromQuery.providerAccount.connectionId) ||
        (this.props.bankAccountFromQuery &&
          this.props.bankAccountFromQuery.company &&
          this.props.bankAccountFromQuery.company.biConnexion &&
          this.props.bankAccountFromQuery.company.biConnexion.connexionId)) || null;;

    const accoundId =
      (this.props.bankAccountFromQuery &&
        this.props.bankAccountFromQuery.providerAccount &&
        this.props.bankAccountFromQuery.providerAccount.accountId) || null;


    const BIData = userId && accoundId ?
      "User ID : " + userId + " - Accound ID : " + accoundId + " - Connect ID : " + connexionId :
      "";

    return (
      <div>
        <FormattedMessage id="ids_banks">
          {backBtnText => (
            <div>
              <SuperpositionHeader
                backUrl="/payments"
                backBtnText={backBtnText2}
                handleMinimizeSidebar={this.props.handleMinimizeSidebar}
              >
                {true && (
                  <ReactSlidingPane
                    isOpen={isPaneOpen}
                    title={this.state.paneTitleIds}
                    width={slidingPaneWidth}
                    onRequestClose={() => this.setState({ isPaneOpen: false })}>
                    {true && (
                      <div>
                        <p>{this.state.paneContentIds}</p>
                        <FormGroup>
                          {!!!this.state.isPaneImport && (
                            <div>
                              <ControlLabel>Password</ControlLabel>
                              <FormControl
                                placeholder="Password"
                                type="password"
                                onChange={e => {
                                  console.log("onchange password");
                                  this.setState({ password: e.target.value });
                                }}
                              />
                            </div>
                          )}

                          {!!this.state.isPaneImport && (
                            <React.Fragment>
                              <BankImportUploader
                                // updateFormValue={updateFormValue}
                                onImportDone={values =>
                                  this.onPaneConfirm(values)
                                }
                                path={`documents/${this.props.companyId
                                  }/bankImport/`}
                                sendNotification={this.props.sendNotification}
                              />
                            </React.Fragment>
                          )}

                          {true && (
                            <CancelButton
                              fill
                              onClick={() =>
                                this.setState({ isPaneOpen: false })
                              }
                            />
                          )}

                          {!!!this.state.isPaneImport && (
                            <Button
                              icon
                              bsStyle="primary"
                              disabled={!(password.length >= 1)}
                              onClick={event => this.onPaneConfirm(event)}>
                              <i className="fa fa-lg fa-check" />
                              <FormattedMessage id="ids_confirm" />
                            </Button>
                          )}

                          {/* {
                            <ConfirmButton
                              disabled={
                                !(
                                  this.state.password &&
                                  this.state.password.length >= 1
                                )
                              }
                            />
                          } */}
                        </FormGroup>
                      </div>
                    )}
                  </ReactSlidingPane>
                )}
                <div
                  className="space-between"
                // style={{ width: "calc(250px + 5%)" }}
                >
                  {!!this.props.bankAccountFromQuery && (
                    <div>
                      <Dropdown
                        pullRight
                        id="expense-validation-dropdown"
                        className="dropdown-action-btn">
                        <Dropdown.Toggle className="btn-wd btn-icon">
                          <i className="fa fa-lg fa-check" />
                          Action
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="action-dropdown-menu">
                          {bankAccount.syncAccount ? (
                            <MenuItem
                              onClick={() =>
                                this.props.onRefreshAccount(
                                  this.state.bankAccount
                                )
                              }
                              eventKey="9">
                              <i className="fa fa-lg fa-refresh" />
                              <FormattedMessage
                                id="ids_refresh"
                                description="refresh bank transactions for the bank account"
                                defaultMessage="Mettre à jour les transactions"
                              />
                            </MenuItem>
                          ) : (
                            <div />
                          )}

                          {!!bankAccount.importedAccount ? (
                            <MenuItem
                              onClick={() =>
                                // console.log("402-", this.state.bankAccount) ||
                                this.showImportSlidingPane()
                              }
                              eventKey="9">
                              <i className="fa fa-lg fa-upload" />
                              <FormattedMessage
                                id="ids_importTransactions"
                                description="import bank transactions for the bank account"
                                defaultMessage="Importer les transactions"
                              />
                            </MenuItem>
                          ) : (
                            <div />
                          )}

                          {bankAccount.syncAccount ? (
                            <MenuItem
                              onClick={() => this.showUnsyncSlidingPane()}
                              eventKey="1">
                              <img
                                src={unsyncSVG}
                                alt="Smiley face"
                                height="14"
                                width="14"
                                style={{ marginRight: "8px" }}
                              />
                              <FormattedMessage id="ids_unsync" />
                            </MenuItem>
                          ) : (
                            <div />
                          )}

                          {!bankAccount.dateCloture ? (
                            <MenuItem
                              onClick={() => this.showCloseSlidingPane()}
                              eventKey="3">
                              <i className="fa fa-lg fa-times" />
                              <FormattedMessage id="ids_cloturer" />
                            </MenuItem>
                          ) : (
                            <div />
                          )}

                          <MenuItem
                            onClick={() => this.showMergeSlidingPane()}
                            eventKey="5">
                            <img
                              src={fusionSVG}
                              alt="Fuisionner"
                              height="14"
                              width="14"
                              style={{ marginRight: "8px" }}
                            />
                            <FormattedMessage id="ids_fuse" />
                          </MenuItem>

                          <MenuItem
                            onClick={() => this.showDeleteSlidingPane()}
                            eventKey="9">
                            <i className="fa fa-lg fa-trash" />
                            <FormattedMessage id="ids_delete" />
                          </MenuItem>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  )}
                  <SaveButton fill onClick={this.onSave} />
                </div>
              </SuperpositionHeader>
            </div>
          )}
        </FormattedMessage>
        <div className="main-content">
          <Grid fluid>
            <Card
              title={<FormattedMessage id="ids_accountSettings" />}
              content={
                //{bankAccountFromQuery.name + " - "}
                //<FormattedMessage id="ids_accountSettings" />
                <form>
                  <FormGroup>
                    <Row>
                      <Col xs={5} sm={4}>
                        <FormGroup
                          validationState={
                            this.state.errors &&
                            this.state.errors.nameValidation
                          }>
                          <ControlLabel>
                            <FormattedMessage
                              id="ids_name"
                              description="bank account edit form name"
                              defaultMessage="Nom"
                            />
                          </ControlLabel>
                          <FormControl
                            type="text"
                            name="bankAccountName"
                            defaultValue={bankAccount.name}
                            onBlur={e =>
                              this.updateFormValue("name", e.target.value)
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col xs={4} sm={3}>
                        <ControlLabel>
                          <FormattedMessage id="ids_type" />
                        </ControlLabel>
                        <FormControl
                          type="text"
                          name="typeBankAccount"
                          value={bankAccount.typeBankAccount}
                          onChange={e =>
                            this.updateFormValue(
                              "typeBankAccount",
                              e.target.value
                            )
                          }
                        />
                      </Col>
                      <Col xs={3} sm={2}>
                        <ControlLabel>
                          <FormattedMessage
                            id="ids_currency"
                            description="Bank account currency input field label"
                            defaultMessage="Devise"
                          />
                        </ControlLabel>
                        <CurrencySelect
                          value={bankAccount.currencyId}
                          onSelected={e =>
                            this.updateFormValue("currencyId", e.value)
                          }
                          disabled={!!this.props.bankAccountFromQuery}
                          error={true}
                        />
                      </Col>

                      {bankAccount.importedAccount && (
                        <Col xs={3} sm={2}>
                          <ControlLabel>
                            <FormattedMessage
                              id="ids_importFormat"
                              description="Import format"
                              defaultMessage="Format d'importation"
                            />
                          </ControlLabel>
                          <BankImportFormatSelect
                            value={bankAccount.importFormat}
                            intl={this.props.intl}
                            onSelected={e =>
                              this.updateFormValue("importFormat", e.value)
                            }
                            disabled={!!this.props.bankAccountFromQuery}
                          />
                        </Col>
                      )}
                    </Row>
                    <Row>
                      <Col xs={8} sm={6}>
                        <ControlLabel>
                          <FormattedMessage id="ids_iban" />
                        </ControlLabel>
                        <Cleave
                          className="form-control"
                          placeholder="FR33 2002 0202 2606 0002 4M02 606"
                          name="iban"
                          style={{ textTransform: "uppercase" }}
                          options={{
                            blocks: [4, 4, 4, 4, 4, 4, 4, 4, 4, 4],
                            delimiter: " "
                          }}
                          value={bankAccount.iban || ""}
                          onChange={e =>
                            this.updateFormValue("iban", e.target.value)
                          }
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        <h3>
                          <FormattedMessage id="ids_pingMeInCaseOf" />
                          <FormattedMessage id="ids_colon" />
                        </h3>
                      </Col>
                      <Col xs={6} sm={3}>
                        <ControlLabel>
                          <FormattedMessage id="ids_expenseGreaterThan" />
                        </ControlLabel>
                        <CurrencyInput
                          currencyId={bankAccount.currencyId}
                          value={bankAccount.alertMaxMontant}
                          update={event =>
                            this.updateFormValue(
                              "alertMaxMontant",
                              parseFloat(event.value)
                            )
                          }
                        />
                      </Col>
                      <Col xs={6} sm={3}>
                        <ControlLabel>
                          <FormattedMessage id="ids_recipeSuperiorTo" />
                        </ControlLabel>
                        <CurrencyInput
                          currencyId={bankAccount.currencyId}
                          value={bankAccount.alertMinMontant}
                          update={event =>
                            this.updateFormValue(
                              "alertMinMontant",
                              parseFloat(event.value)
                            )
                          }
                        />
                      </Col>
                      <Col xs={6} sm={3}>
                        <ControlLabel>
                          <FormattedMessage id="ids_balanceLowerThan" />
                        </ControlLabel>
                        <CurrencyInput
                          currencyId={bankAccount.currencyId}
                          value={bankAccount.alertMinSolde}
                          update={event =>
                            this.updateFormValue(
                              "alertMinSolde",
                              parseFloat(event.value)
                            )
                          }
                        />
                      </Col>
                      <Col xs={6} sm={3}>
                        <ControlLabel>
                          <FormattedMessage id="ids_balanceGreaterThan" />
                        </ControlLabel>
                        <CurrencyInput
                          currencyId={bankAccount.currencyId}
                          value={bankAccount.alertMaxSolde}
                          update={event =>
                            this.updateFormValue(
                              "alertMaxSolde",
                              parseFloat(event.value)
                            )
                          }
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        <h3>
                          <FormattedMessage id="ids_otherSettings" />
                        </h3>
                      </Col>
                      <Col xs={8} sm={6}>
                        <ControlLabel>
                          <FormattedMessage id="ids_codeJournal" />
                        </ControlLabel>
                        <FormControl
                          type="text"
                          name="bankAccountCodeJournal"
                          style={{ textTransform: "uppercase" }}
                          value={bankAccount.codeJournal}
                          onChange={e =>
                            this.updateFormValue("codeJournal", e.target.value)
                          }
                        />
                      </Col>
                      <Col xs={12}>
                        <br />
                        <br />
                        <Col xs={4}>
                          {/* <LocalizedSwitchYesNo
                            // onText="✔"
                            // offText="✘"
                            value={bankAccount.syncAccount}
                            onChange={(e, state) =>
                              this.updateFormValue("syncAccount", state)
                            }
                          /> */}

                          {bankAccount.syncAccount &&
                            bankAccount.providerAccountError === null ? (
                            <div align="center" title={BIData}>
                              <i className="fa fa-lg fa-check text-success" />{" "}
                              <FormattedMessage id="ids_synchronizedAccount" />
                            </div>
                          ) : (
                            <div />
                          )}

                          {bankAccount.syncAccount &&
                            bankAccount.providerAccountError !== null ? (
                            <div align="center" title={BIData}>
                              <i className="fa fa-lg fa-warning text-warning" />{" "}
                              <FormattedMessage id="ids_synchronizedAccount" />
                            </div>
                          ) : (
                            <div />
                          )}

                          {!!!bankAccount.syncAccount ? (
                            <div align="center">
                              <i className="fa fa-lg fa-times text-danger" />{" "}
                              <FormattedMessage id="ids_unsynchronizedAccount" />
                            </div>
                          ) : (
                            <div />
                          )}
                        </Col>
                        <Col xs={4}>
                          <PaymentLastUpdate
                            id={bankAccount.id}
                            locale={locale}
                          />
                        </Col>

                        <Col xs={4}>
                          {bankAccount.dateCloture ? (
                            <div align="center">
                              <i className="fa fa-lg fa-times text-danger" />{" "}
                              <FormattedMessage id="ids_closedAccount" />{" "}
                              {closedAtDate}
                            </div>
                          ) : (
                            <div />
                          )}
                        </Col>
                      </Col>

                      {
                        // <Col xs={12}>
                        //   <br/>
                        //   <Switch
                        //     onText="✔"
                        //     offText="✘"
                        //     value={bankAccount.active}
                        //     onChange={(e, state) => updateFormValue("active", state)}
                        //     />
                        //   <FormattedMessage id='bank_account_edit_form_active_switch_label'
                        //     description="bank account edit form active switch label"
                        //     defaultMessage="Compte actif"/>
                        // </Col>
                      }
                    </Row>
                  </FormGroup>
                </form>
              }
            />
          </Grid>
        </div>
      </div>
    );
  };
}
const userProfile = graphql(Queries.userProfile, {
  name: "userProfile"
});

const authenticateUserMutation = graphql(Queries.AuthenticateUserMutation, {
  name: "authenticateUserMutation",
  fetchPolicy: "no-cache",
  options: { fetchPolicy: "no-cache" }
});
export default compose(
  userProfile,
  authenticateUserMutation
)(injectIntl(withRouter(BankAccountForm)));
